import InnerPagePublications from './innerPagePublications'
import TemplateMain from '../templateMain'
export default function PagePublications () {
  return (
    <TemplateMain
      g_section='portfolio'
      htmlTitle='Publications'
      linksTitle='Highlighted Articles'
      innerPage={<InnerPagePublications />}
      g_sidebarKey='pagePublications'
      g_slideshowKey=''
    />
  )
}
